import { useQuery } from '@tanstack/react-query';
import { keywordsApi, type KeywordEvent, type KeywordEventsResponse } from '../api/keywordsApi';

interface UseEventsByKeywordsParams {
  keywordIds: string[];
  includePast?: boolean;
  limit?: number;
  offset?: number;
  search?: string;
  enabled?: boolean;
}

export const useEventsByKeywords = ({ 
  keywordIds, 
  includePast = false, 
  limit = 12,
  offset = 0,
  search,
  enabled = true 
}: UseEventsByKeywordsParams) => {
  return useQuery<KeywordEventsResponse, Error>({
    queryKey: ['portal', 'keywords', 'events', keywordIds, includePast, limit, offset, search],
    queryFn: () => keywordsApi.getEventsByKeywords({ 
      keywordIds, 
      includePast, 
      limit,
      offset,
      search 
    }),
    enabled: enabled && keywordIds.length > 0,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2,
    retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};

// Hook to fetch all keywords for the team
export const useKeywords = () => {
  return useQuery({
    queryKey: ['portal', 'keywords'],
    queryFn: () => keywordsApi.getKeywords(),
    staleTime: 10 * 60 * 1000, // 10 minutes - keywords don't change often
    retry: 2,
  });
};